import { Component, EventEmitter, Input, Output, OnDestroy, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from "rxjs";
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import { ItemService, UserService, PermissionService, EventService } from '../services';
import { filter, first } from 'rxjs/operators';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog'
import { CopyItemDialogComponent } from './copyItemDialog.component';

@Component({
    selector: 'item-summary',
    styles: [`

        :host-context(.item-details) .mat-card {
            padding-bottom: 0px;
            box-shadow: 0 3px 1px -2px #ffffff, 0 2px 2px 0 #ffffff, 0 1px 5px 0 #ffffff;
        }

        .new-item-card {
            border-left-style: solid;
            border-left-color: #F88F1E;
            border-left-width: 4px;
        }

        mat-card-title {
            margin-bottom: 8px;
        }

        mat-card-title a {
            text-decoration: none;
        }
        
        .divider {
            margin-right: 10px;
            margin-top: -3px;
        }
        
        .divider i {
            color: #B2B2B3;
            font-size: 5px;
        }
        
        .item-back {
            cursor: pointer;
        }
        .item-navigation {
            color: #B2B2B3;
        }
        
        .item-visited {
            color: #551a8b;
        }
        
        .full-text-link {
            padding-top: 10px;
        }

        .full-text-link a {
            cursor: pointer;
        }
        
        .item-card {
            margin-bottom: 3px;
        }
        
        .item-left-detail {
            padding-right: 7px;
        }
        
        .item-detail {
            font-size: 12px;
        }
        
        .nav-arrow {
            font-size: 55px;
        }

        .item-title-small {
            min-height: 47px;
            max-height: 47px;
            overflow-y: hidden;
        }
        
        .author-small {
            text-overflow: ellipsis;
            overflow-x: hidden;
            max-height: 18px;
            height: 18px;
        }

        .small-button {
            margin-top: -3px;
            height: 20px;
            width: 20px;
            line-height: 20px;
        }

        .small-button i {
            font-size: 15px;
        }
    `],
    template: `
        <mat-card class="item-card" [ngClass]="{ 'new-item-card': isNew }" [ngStyle]="{'opacity' : !item.visible && !visibilityDisabled? 0.5 : .99}">
            <mat-card-content>
                <div fxLayout="row">
                    <div *ngIf="previousId && mqAlias !== 'xs'" style="padding-right: 20px;">
                        <a class="item-navigation item-back" (click)="goToItem.emit(previousId)"><i class="nav-arrow fa fa-angle-left"></i></a>
                    </div>
                    <div fxFlex fxLayout="row">
                        <div style="width:60px;">
                            <curation-rank *ngIf="curating" [score]="item?.curationRank"></curation-rank>
                            <rank *ngIf="!curating" [score]="item?.attentionRank"></rank>
                        </div>
                        <div fxFlex fx>
                            <mat-card-title style="font-size: 20px;" [ngClass]="{'item-title-small': detailSummary && (mqAlias === 'sm' || mqAlias === 'xs')}">
                                <a *ngIf="!noLink && !disableTitle && !deadLink" [routerLink]="[baseRouteLink, item.id]" queryParamsHandling="merge" [ngClass]="{'item-visited': item?.readByUser }" class="item-back item-title">{{item.title}}</a>
                                <a *ngIf="noLink && !disableTitle && !deadLink"  (click)="externalLinkClicked.emit()" href="{{item.link}}" target="_blank" class="item-back item-title">{{item.title}}</a>
                                <span *ngIf="disableTitle || deadLink">{{item.title}}</span>
                            </mat-card-title>

                            <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
                                <div class="item-detail item-left-detail">{{item.streamOriginTitle}}</div>
                                <div *ngIf="item.author" class="divider" fxHide.sm fxHide.xs><i class="fa fa-circle"></i></div>
                                <div class="item-detail item-left-detail" [ngClass]="{'author-small': detailSummary && (mqAlias === 'sm' || mqAlias === 'xs')}">{{item.author}}</div>
                                <div *ngIf="!detailSummary" class="divider" fxHide.sm fxHide.xs><i class="fa fa-circle"></i></div>
                                <div style="padding-right: 10px;" class="item-detail" fxHide.sm fxHide.xs [matTooltip]="item.publishedDate | date: 'medium'">{{item.publishedDate | date }}</div>
                                <span *ngIf="!curating" fxHide.sm fxHide.xs>
                                    <button *ngIf="isReadable() && !detailSummary && currentUser()"  
                                            class="small-button" 
                                            mat-icon-button
                                            [matTooltip]="item?.savedByUser ? 'Unsave' : 'Save'"
                                            style="margin-right: 10px; margin-top: -5px;"
                                            (click)="toggleSaved()">
                                        <i class="material-icons">{{item?.savedByUser ? 'bookmark' : 'bookmark_border'}}</i>
                                    </button>
                                    <button *ngIf="isReadable() && !detailSummary && currentUser()"
                                            class="small-button"
                                            mat-icon-button 
                                            matTooltip="Share"
                                            matTooltipPosition="above"
                                            style="margin-right: 10px; margin-top: -5px;"                                        
                                            (click)="emailShare()">
                                        <i class="material-icons">share</i>
                                    </button>
                                    <button *ngIf="isStreamManager && !detailSummary "
                                            class="small-button"
                                            mat-icon-button 
                                            matTooltip="Copy"
                                            matTooltipPosition="above"
                                            style="margin-right: 10px; margin-top: -5px;"                                        
                                            (click)="copy()">
                                        <i class="material-icons">file_copy</i>
                                    </button>
                                    <span *ngIf="isReadable() && !detailSummary && currentUser()">
                                        <button class="small-button"
                                                mat-icon-button 
                                                [matTooltip]="item?.likedByUser ? 'Unlike' : 'Like'"
                                                matTooltipPosition="above"
                                                style="margin-top: -5px;"
                                                [ngClass]="{'active-thumb': item?.likedByUser}"
                                                (click)="toggleLikedBy()">
                                            <i class="material-icons">thumb_up</i>
                                        </button>
                                        <span *ngIf="item && item.likesCount" [matTooltip]="(item?.likesCount || 0) + ' likes'">({{item?.likesCount || 0}})</span>
                                    </span>
                                    <span *ngIf="isEditable()">
                                        <button class="small-button"
                                                mat-icon-button 
                                                matTooltip="Edit"
                                                matTooltipPosition="above"
                                                style="margin-top: -5px;"
                                                [routerLink]="['/topics', topic.id, 'content', 'items', 'post']"
                                                [queryParams]="{ itemId: item.id }">
                                            <i class="material-icons">edit</i>
                                        </button>
                                    </span>
                                    <span *ngIf="isAdmin && !detailSummary && !visibilityDisabled">
                                        <button style="margin-left: 10px;"
                                                class="small-button"
                                                mat-icon-button 
                                                [matTooltip]="item.visible ? 'Hide item' : 'Show item'"
                                                (click)="toggleVisibility()">
                                            <mat-icon>{{item.visible ? 'visibility' : 'visibility_off'}}</mat-icon>
                                        </button>
                                    </span>
                                </span>
                                <div fxLayout="row" fxHide.gt-sm>
                                    <div class="item-detail" [matTooltip]="item.    publishedDate | date: 'medium'">{{item.publishedDate | date }}</div>
                                    <button *ngIf="isReadable() && !detailSummary " class="small-button" mat-icon-button
                                            [matTooltip]="item?.savedByUser ? 'Unsave' : 'Save'"
                                            (click)="toggleSaved()" style="margin-left: 10px; margin-top: -4px;">
                                        <i class="material-icons">{{item?.savedByUser ? 'bookmark' : 'bookmark_border'}}</i>
                                    </button>
                                    <button *ngIf="!detailSummary && isReadable() && currentUser()"
                                        class="small-button"
                                        style="margin-left: 8px; margin-top: -4px"
                                        mat-icon-button 
                                        matTooltip="Share"
                                        matTooltipPosition="above"
                                        (click)="emailShare()">
                                        <i class="material-icons">share</i>
                                    </button>
                                    <button *ngIf="isReadable() && currentUser()"
                                        class="small-button"
                                        style="margin-left: 8px; margin-top: -4px"
                                        [style.color]="item?.likedByUser ? 'inherit' : 'gray'"
                                        mat-icon-button 
                                        [matTooltip]="item?.likedByUser ? 'Unlike' : 'Like'"
                                        matTooltipPosition="above"
                                        (click)="toggleLikedBy()">
                                        <i class="material-icons">thumb_up</i>
                                    </button>
                                    <span *ngIf="item && item.likesCount" [matTooltip]="(item?.likesCount || 0) + ' likes'">({{item?.likesCount || 0}})</span>
                                    <button *ngIf="isAdmin && !visibilityDisabled"
                                            style="margin-left: 10px;"
                                            class="small-button"
                                            mat-icon-button 
                                            [matTooltip]="item.visible ? 'Hide item' : 'Show item'"
                                            (click)="toggleVisibility()">
                                        <mat-icon>{{item.visible ? 'visibility' : 'visibility_off'}}</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" *ngIf="!detailSummary" style="padding-top: 10px;">
                                <div fxFlex="80">{{item.shortDescription}}</div>
                            </div>
                        </div>
                        <div *ngIf="curating && !detailSummary" style="width: 40px; padding: 30px;">
                            <button *ngIf="isAdmin && !visibilityDisabled"
                                    style="width: 40px"
                                    class="small-button"
                                    mat-icon-button 
                                    [matTooltip]="item.visible ? 'Hide item' : 'Show item'"
                                    (click)="toggleVisibility()">
                                <mat-icon style="font-size: 40px;">{{item.visible ? 'visibility' : 'visibility_off'}}</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="curating && !detailSummary" style="width: 40px; padding: 30px;">
                            <button *ngIf="isAdmin"
                                    style="width: 40px"
                                    class="small-button"
                                    mat-icon-button
                                    [matTooltip]="item.inCurationItems ? 'remove from training set' : 'add to training set'"
                                    (click)="toggleCurationItem()">
                                <mat-icon style="font-size: 40px;" fontSet="far" [fontIcon]="item.inCurationItems ? 'fa-check-circle' : 'fa-circle'"></mat-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="nextId && mqAlias !== 'xs'" style="padding-left: 20px;"><a class="item-navigation item-back" (click)="goToItem.emit(nextId)"><i class="nav-arrow fa fa-angle-right"></i></a></div>
                </div>
            </mat-card-content>
        </mat-card>
    `})
export class ItemSummary implements OnDestroy, OnInit, OnChanges {
    @Input() item: any;
    @Input() isAdmin = false;
    @Input() topic: any;
    @Input() noLink = false;
    @Input() nextId: string;
    @Input() previousId: string;
    @Input() disableTitle = false;
    @Input() detailSummary = false;
    @Input() curating = false;
    @Input() topicId: string;
    @Input() subscription: any;
    @Input() baseRouteLink = './items';
    @Input() visibilityDisabled = false;
    @Output() goToItem = new EventEmitter<string>();
    @Output() externalLinkClicked = new EventEmitter<null>();
    @Output() curationSetChanged = new EventEmitter<null>();
    @Output() visibilityChanged = new EventEmitter<boolean>();
    mediaSubscription: Subscription;
    mqAlias: string;
    processingLike: any;
    isNew: boolean;
    isStreamManager: boolean;
    
    constructor(media: MediaObserver,
                private dialog: MatDialog, 
                private eventService: EventService,
                private itemService: ItemService,
                private permissionService: PermissionService, 
                private userService: UserService){
        this.mediaSubscription = media.media$.subscribe((change: MediaChange) => {
            this.mqAlias = change.mqAlias;
        });
    }

    ngOnInit(): void {
        this.isStreamManager = this.permissionService.currentUserIsStreamManager();
    }

    ngOnDestroy() {
        [this.mediaSubscription].forEach(sub => sub ? sub.unsubscribe() : null);
    };

    isReadable() {
        return this.itemService.isReadable(this.topic, this.item);
    }

    isEditable() {
        return false;
        /* 
        this.topic && this.topic.type === 'COLLECTION' && 
               ['COPY', 'MANUAL'].includes(this.item.type) &&
               this.permissionService.currentUserHasPermission({ 
                    action: 'MANAGE_STREAM',
                    streamId: this.topic.id,
                    streamOwnerId: this.topic.ownerId,
                    userId: this.userService.getCurrentUser() ? this.userService.getCurrentUser().id : undefined
               });
        */
    }

    emailShare() {
        return this.itemService.shareItemByEmail(this.item, this.topic);
    }

    copy(): void {
        this.dialog.open(CopyItemDialogComponent, { data: this.item.id }).afterClosed()
        .pipe(filter(res => !!res))
        .subscribe(topicId => this.itemService.focusedItemEdit.next({ sourceItemId: this.item.id, topicId }));
    }

    toggleLikedBy() {
        if(!this.processingLike) {
            this.processingLike = true;
            this.itemService.toggleLikedBy(this.item).pipe(first()).subscribe(() => this.processingLike = false);
        }
    }

    currentUser() {
        return this.userService.getCurrentUser();
    }

    toggleSaved() {
        return this.itemService.toggleItemSaved(this.item);
    }

    toggleVisibility() {
        this.item.visible = !this.item.visible;
        const patch = this.topic.curated ? { exposed: this.item.visible } : { hidden: !this.item.visible };
        this.itemService.patchItem(this.topic.id, this.item.id, patch)
        .subscribe(() => {
            this.visibilityChanged.emit(this.item.visible);
            const label = this.item.visible ? 'show_item' : 'hide_item';
            this.eventService.postStreamItemEvent(label, undefined, this.item, this.topic);
        });
    }

    toggleCurationItem() {
        this.itemService.toggleCurationItem(this.item, this.topic).subscribe(() => this.curationSetChanged.emit());
    }

    get deadLink(): boolean {
        return this.detailSummary && (!this.item?.link || ['', '#'].includes(this.item.link.trim()));
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Hello person from the future! Do we have flying cars yet?
        // Anyway the following is to account for the fact that
        // the api does not always populate all attributes at all times 
        // (please refer to Jefferson on the point) and since multiple 
        // fetches would be a no no, we need to account for the missing 
        // information based off of previous information
        if (changes.item && 
            changes.item.previousValue?.id === changes.item.currentValue?.id &&
            changes.item.currentValue?.visible === undefined &&
            changes.item.previousValue?.visible !== undefined) {
            this.item.visible = changes.item.previousValue.visible;
        }

        this.isNew = this.topic && 
                     this.subscription && 
                     (!this.subscription.lastOpenedDate || 
                      moment(this.subscription.lastOpenedDate).isBefore(moment(this.item.created)));
    }
}
